module.exports = __webpack_public_path__ + "img/13.14446534.jpg";